import React, { useState } from 'react'
import { Badge, Button, Modal, Image } from 'antd'
import { connect } from 'react-redux'
import capitalize from 'lodash/capitalize'
import { InfoCircleOutlined, ArrowLeftOutlined } from '@ant-design/icons'
import '../css/admin.lite.scss'
import { isEmpty } from 'lodash'
import moment from 'moment'
import util from '../../util/util'
import {
  addComment,
  updateLastViewed,
  getMessageCase,
  setPatientAndMsg,
  setSingleMsg,
  getImageUrl,
} from '../../store/action/actioncases.action'
import { constants } from '../../constants'
import { useHistory, Redirect } from 'react-router-dom'
import PatientInfo from './patient.drawer'
import ZoomableImage from '../../component/zoom/zoom.image'
const PatientMessage = (props) => {
  const [open, setOpen] = useState(false)
  const [imageUrl, setImageUrl] = useState([])
  const [imageopen, setImageOpen] = useState(false)
  var history = useHistory()
  const patientAndMsg = props?.patientAndMsg
  // console.log(patientAndMsg, 'patientAndMsg')

  const handleNavigate = async (path, pathName) => {
    await history.push({ pathname: pathName, search: constants.ADMIN_LITE })
    if (!window.ReactNativeWebView) return
    await window.ReactNativeWebView.postMessage(
      JSON.stringify({
        route: '/navigate',
        data: { path },
      })
    )
  }
  const handleMsgClick = (data) => {
    props.setSingleMsg(data)
    const path = `/message-interface${constants.ADMIN_LITE}`
    const pathName = '/message-interface'
    handleNavigate(path, pathName)
  }

  const handleBack = (data) => {
    props.setSingleMsg(data)
    const path = `/messages${constants.ADMIN_LITE}`
    const pathName = '/messages'
    handleNavigate(path, pathName)
  }
  const handleDrawer = (isOpen = false) => {
    setOpen(isOpen)
  }
  const handleDescription = (msg) => {
    let comment =
      msg.comments?.length > 0 ? msg.comments[0]?.comment : msg.description
    return (
      <>
        {comment.length > 80 ? (
          comment.slice(0, 80) + '...'
        ) : comment == 'NA' &&
          !isEmpty(msg.comments) &&
          !isEmpty(msg.comments[0].imageUrl) ? (
          <>
            <img
              style={{ height: 30 }}
              alt='Image Preview'
              src={msg.comments[0].imageUrl.thumbnail}
              onClick={(e) =>
                viewImage(
                  e,
                  msg.comments[0].imageUrl.original,
                  constants.AWS_FOLDER_NAME.MESSAGE
                )
              }
            />
          </>
        ) : (
          comment
        )}
      </>
    )
  }
  const getUserName = (msg) => {
    let userName =
      msg.comments?.length > 0
        ? msg.comments[0]?.userName
        : msg.reportedUsername
    return <>{userName}</>
  }
  const getDate = (msg) => {
    let date =
      msg.comments?.length > 0
        ? moment(msg.comments[0]?.commented_date).format('MMM D, h:mm A')
        : moment(msg.lastUpdated).format('MMM D, h:mm A')
    return <>{date}</>
  }
  const viewImage = async (e, fileName) => {
    try {
      e.stopPropagation()
      const res = await props.getImageUrl({
        fileName,
        type: constants.AWS_FOLDER_NAME.MESSAGE,
      })
      setImageUrl(res.imageUrl)
      setImageOpen(true)
    } catch (err) {
      console.log(err, 'Error in viewImage')
    }
  }
  const renderImageModal = () => (
    <ZoomableImage
      src={imageUrl}
      open={imageopen}
      onClose={(visible) => setImageOpen(false)}
    />
    // <Image
    //   src={imageUrl}
    //   style={{ display: 'none' }}
    //   preview={{
    //     visible: imageopen,
    //     onVisibleChange: (visible) => setImageOpen(visible),
    //     height:'80%',
    //   }}
    // />
  )
  return (
    <div className='admin-lite'>
      <div className='patientmessage-container'>
        <div className='chat-layout'>
          {open && (
            <PatientInfo
              open={open}
              handleDrawer={handleDrawer}
              patient={patientAndMsg?.patient}
            />
          )}
          {/* Header */}
          <div className='chat-header'>
            <span className='arrow-left' onClick={() => handleBack(1)}>
              <ArrowLeftOutlined style={{ fontSize: 22, cursor: 'pointer' }} />
            </span>
            <span className='chat-title'>
              {capitalize(patientAndMsg?.patient?.firstname) +
                ' ' +
                capitalize(patientAndMsg?.patient?.lastname)}
            </span>
            <Button
              className='patient-info-container'
              type='primary'
              onClick={() => handleDrawer(true)}
            >
              {' '}
              Patient Info
            </Button>

            {/* <InfoCircleOutlined
          className='icon'
          onClick={() => handleDrawer(true)}
        /> */}
          </div>

          {/* Messages */}

          <div className='messages'>
            {!isEmpty(patientAndMsg) &&
              patientAndMsg?.messages.map((msg, idx) => (
                <div
                  className='outermessage message-div leftdiv reply-div'
                  onClick={() =>
                    handleMsgClick({
                      message: msg,
                      patient: patientAndMsg?.patient,
                    })
                  }
                >
                  {/* <div className='messages-div'>
                <div className='sender'>
                  <strong>
                    {msg.reportedBy === ''
                      ? 'You'
                      : msg.reportedUsername
                        ? msg.reportedUsername
                        : 'Surgery Center'}
                  </strong>
                </div>
              </div> */}
                  <Badge count={msg.newCommentCount || 0} key={msg.caseId}>
                    <div className='messages-body'>
                      <div className='chat-bubble'>
                        <div style={{ display: 'flex' }}>
                          <div className='message-div-username'>
                            {getUserName(msg)}

                            {/* {comment.userid == patientid} */}
                          </div>
                          <div className='message-div-date'>{getDate(msg)}</div>
                        </div>
                        <div className='chat-bubble-summary'>{msg.summary}</div>
                        <div className='messages-body-pre'>
                          {handleDescription(msg)}
                        </div>
                        <div className='reply-div'>View</div>
                      </div>
                      {/* <div className='timestamp'>
                    {moment(msg.lastUpdated).format('MMM D, h:mm A')}
                  </div> */}
                    </div>
                  </Badge>
                </div>
              ))}
          </div>
          {renderImageModal()}
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    patient: state.patient.patient,
    editCase: state.actioncase.editcase,
    singleMsg: state.actioncase.singleMsg,
    patientAndMsg: state.actioncase.patientAndMsg,
    isLoading: state.actioncase.isLoading,
    healthCoachList: state.actioncase.healthCoachList,
    token: util.verifyToken(state.profile.token),
    company: state.profile.company,
    current_user: state.profile.user,
    patientLoading: state.patient.isLoading,
    customer: state.profile.customer,
    searchText: state.user.searchText,
    user: state.profile.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getMessageCase: (params) => dispatch(getMessageCase(params)),
    addComment: (data) => dispatch(addComment(data)),
    updateLastViewed: (caseId) => dispatch(updateLastViewed(caseId)),
    setPatientAndMsg: (params) => dispatch(setPatientAndMsg(params)),
    setSingleMsg: (params) => dispatch(setSingleMsg(params)),
    getImageUrl: (params) => dispatch(getImageUrl(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientMessage)
